/**
 * Gets a string with the copyright and current year.
 * @function
 * @name getCopyright
 * @kind function
 * @returns {string} string with the copyright and current year.
 * @exports
 */
export function getCopyright(): string {
  const date = new Date().getFullYear();
  return "© Finopay By Zenith " + date;
}
